// Entry point for the build script in your package.json
import { createRoot } from "react-dom/client";

import "core-js/stable";
import "regenerator-runtime/runtime";

import "leaflet";
import "leaflet.markercluster";
import "leaflet-gesture-handling";

// Initialization scripts
import "./config/polyfills";
import "./config/initializers";
import "./config/appsignal";

import "./authentication/smsDeliveryStatusPoll";

import AppContainer from "./components/AppContainer";
import SignUpApp from "./components/SignUpApp/SignUpApp";

document.addEventListener("DOMContentLoaded", () => {
  const appContainerRoot = document.querySelector("[data-react-app='AppContainer']");

  if (appContainerRoot) {
    const props = JSON.parse(appContainerRoot.dataset.reactProps);
    const root = createRoot(appContainerRoot);

    root.render(<AppContainer {...props} />);
  }

  const signUpAppRoot = document.querySelector("[data-react-app='SignUpApp']");

  if (signUpAppRoot) {
    const props = JSON.parse(signUpAppRoot.dataset.reactProps);
    const root = createRoot(signUpAppRoot);

    root.render(<SignUpApp {...props} />);
  }
});
